import { fractionWithPercentage } from "./number_formatting_utils";
import { trunc } from "lodash";

export const PositionTypes = {
  Page: "page",
  Percent: "percent",
};

export function hasProgress(readingSession) {
  return readingSession.currentPosition !== 0;
}

export function truncateBookTitle(title, maxLength = 80) {
  return trunc(title, {
    omission: "…",
    length: maxLength,
  });
}

export function isValidUpdate(session) {
  return session.body.length > 0 || session.currentPosition.toString().length > 0;
}

const isValidPageProgress = (session) => parseInt(session.currentPosition) >= 0;

const isValidPercentProgress = (session) =>
  parseInt(session.currentPosition) >= 0 && parseInt(session.currentPosition) <= 100;

export function isValidProgressAmount(session) {
  if (session.positionType === PositionTypes.Page) {
    return isValidPageProgress(session);
  } else if (session.positionType === PositionTypes.Percent) {
    return isValidPercentProgress(session);
  }
  return false;
}

export function invalidProgressMessage(session) {
  if (session.positionType === PositionTypes.Page) {
    return "Please enter a page number that is positive.";
  } else if (session.positionType === PositionTypes.Percent) {
    return "Please enter a percentage between 0 and 100.";
  }
  return "Invalid input";
}

/**
 * Returns true if the supplied ReadingSession-shaped data
 * can be displayed as a percent, meaning it either _is_
 * based directly on percent or has a page number out of a
 * known total number of pages. Some books don't have a numPages
 * attribute.
 *
 * There is a related function, user_status_helper#isDisplayableAsPercent
 * for the equivalent for UserStatus-shaped data.
 *
 * @param readingSession
 * @returns {boolean}
 */
export function isDisplayableAsPercent(readingSession) {

  // Note: finalPosition can refer to either 100 (when percent)
  // or the book's page count
  return readingSession.positionType === PositionTypes.Percent ||
    (readingSession.positionType === PositionTypes.Page && readingSession.finalPosition);
}

export function currentPositionLabel(readingSession) {
  if (readingSession.positionType === PositionTypes.Page) {
    if (isDisplayableAsPercent(readingSession)) {
      return fractionWithPercentage(readingSession.currentPosition,
                                    readingSession.finalPosition);
    } else {
      return `On page ${readingSession.currentPosition}`;
    }
  } else {
    return `${readingSession.currentPosition}%`;
  }
}
